import type { ValueFormatterParams } from "ag-grid-community";

/**
 * Standardized cell data access utility
 */
export const getCellData = (params: ValueFormatterParams): unknown => {
  const colId = params.column.getColId();
  return params.data?.[colId] ?? null;
};

/**
 * Numeric value extraction tolerant to primitives
 */
export const extractNumericValue = (cellData: unknown): number | null => {
  if (cellData == null) {
    return null;
  }
  if (typeof cellData === "number") {
    return isNaN(cellData) ? null : cellData;
  }
  if (typeof cellData === "string") {
    const parsed = Number(cellData.replace?.(/%/g, ""));
    return isNaN(parsed) ? null : parsed;
  }
  return null;
};

/**
 * Standardized column configuration for numeric data
 */
export const getNumericFilterParams = () => ({
  buttons: ["reset", "apply"],
  newRowsAction: "keep",
  suppressAndOrCondition: true,
  closeOnApply: true,
});

export const getNumericColumnConfig = () => ({
  filter: "agNumberColumnFilter",
  cellDataType: "number" as const,
  cellStyle: { textAlign: "right" },
  filterParams: getNumericFilterParams(),
});
